module.exports = __webpack_public_path__ + "72dab47213dfbfe573e8b3b8f0dc91bb.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/KW.svg
// module id = yhs6
// module chunks = 0